/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const DELETE_ITEM = 'MFE/MBP-CHECKOUT/DELETE_ITEM';
const HANDLE_DELETE_ITEM_FOOD = 'MFE/MBP-CHECKOUT/HANDLE_DELETE_ITEM_FOOD';
const ENTERPRISE_DELETE_ITEM = 'MFE/MBP-CHECKOUT/ENTERPRISE_DELETE_ITEM';

export {
    DELETE_ITEM,
    HANDLE_DELETE_ITEM_FOOD,
    ENTERPRISE_DELETE_ITEM,
};

export default {};
